import React, { Dispatch, SetStateAction } from 'react';
import { Outlet, useOutletContext } from 'react-router-dom';

import { UseOutletContextInventory } from '../Inventory';
import { AppService } from '../../../../models/app.service.model';
import { Company } from '../../../../models/company.model';
import { Settings } from '../../../../models/settings.model';
import { Category } from '../../../../models/category.model';
import { Service } from '../../../../models/service.model';
import { StorageCenter } from '../../../../models/storage.center.model';

export interface AssetPageProps {};

type ContexType = {
  setRoute: Dispatch<SetStateAction<{path: {root: string, branch: string} | null, company: boolean} | null>>,
  appServiceForUser: AppService | null,
  companyForUser: Company | null,
  settingsForCompany: Settings | null,
  categoriesForCompany: Category[] | null,
  servicesForCompany: Service[] | null,
  storageCentersForCompany: StorageCenter[] | null
};

const AssetPage: React.FunctionComponent<AssetPageProps> = props => {
  const {setRoute, appServiceForUser, companyForUser, settingsForCompany, categoriesForCompany, servicesForCompany, storageCentersForCompany} = UseOutletContextInventory()

  return (
    <Outlet context={{setRoute, appServiceForUser, companyForUser, settingsForCompany, categoriesForCompany, servicesForCompany, storageCentersForCompany}}></Outlet>
  );
}

export function UseOutletContextAsset() {
  return useOutletContext<ContexType>()
};

export default AssetPage;
